import { pxToRem, useAppDisplayModeContext } from '@archipro-design/aria';

import type { FilterStates } from '@modules/search/type/filter-state';

import type { ElasticSearchCategories } from '@modules/search/type/api';
import type { FilterStatesKey } from '~/modules/search/type/filter-state';

import type { useSearchFilters } from '@modules/search/hook/use-search-filters';
import type { ReactElement } from 'react';

import { CategoryFilterSection as CategoryFilterSectionDesktop } from './CategoryFilterSection.desktop';
import { CategoryFilterSection as CategoryFilterSectionMobile } from './CategoryFilterSection.mobile';

export interface CategoryFilterSectionProps {
    category?: ElasticSearchCategories;
    initialStates: FilterStates | null;
    filterDrawerOpen: boolean;
    toggleFilterDrawer: () => void;
    componentBefore?: ReactElement;
    componentBarAddon?: ReactElement;
    searchFilters: ReturnType<typeof useSearchFilters>;
    hideToggleFilterButton?: boolean;
}

export const CATEGORY_IGNORE_FILTER_KEYS: FilterStatesKey[] = ['libraryRanges'];

export const CategoryFilterSection = (props: CategoryFilterSectionProps) => {
    const { desktop } = useAppDisplayModeContext();

    return desktop ? (
        <div
            style={
                props.filterDrawerOpen
                    ? {
                          paddingLeft: pxToRem(460),
                          transition: 'padding-left 0.3s ease-in-out',
                      }
                    : {
                          paddingLeft: pxToRem(0),
                          transition: 'padding-left 0.3s ease-in-out',
                      }
            }
        >
            <CategoryFilterSectionDesktop {...props} />
        </div>
    ) : (
        <CategoryFilterSectionMobile {...props} />
    );
};
